import React, { useEffect, useState } from 'react';
import { CardSection, CardTitle } from '../RelatedArticlesNew/styled';
import { useRouter } from 'next/router';
import { getSimilarData } from '../../../Utils/helper';
import { QNAList } from './styled';
import { images } from '../../../Constants/ImageUrls';
import { getFirebaseLiveData } from '../../../Utils/firebaseLiveData';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import { getSearchParams } from '../../Parenting/common';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { question_views_add_on } from '../../../Constants/QuestionPage';
import {
  fireClickedCardEvent,
  fireServedSectionEvent,
} from '../../../Utils/useFirebase';

export default function RelatedQuestionNew(props) {
  const { pageType, similarElements, questionId } = props;
  let questions = getSimilarData(similarElements, 'question');
  const [questionViews, setQuestionViews] = useState([]);
  const [cardEffect, setCardEffect] = useState({ index: null, effect: '' });
  const router = useRouter();

  const makeQuestionsViewsData = async () => {
    if (questions?.length > 0) {
      let cardId = [];
      questions.forEach((element) => {
        cardId.push(element.id);
      });
      fireServedSectionEvent('related Question', cardId, pageType);

      let question_views = [];
      const { getValues } = getFirebaseLiveData();
      await questions.forEach(async (element) => {
        const updatedData = await getValues('Views/Question/', element?.id);
        question_views.push(
          (updatedData?.views || 0) + (element?.id % question_views_add_on),
        );
        if (question_views.length === questions?.length)
          setQuestionViews(question_views);
      });
    }
  };

  useEffect(() => {
    makeQuestionsViewsData();
  }, []);

  useEffect(() => {
    setCardEffect({ index: null, effect: '' });
  }, [questionId]);
  return (
    <>
      {questions?.length > 0 ? (
        <CardSection>
          <CardTitle as="h2">Related Questions</CardTitle>
          <QNAList>
            {questions?.map((element, index) => {
              const views = questionViews[index];
              const web_url = element?.web_url;
              return (
                <AnchorCoverTag
                  url={web_url}
                  key={`related_article${index}`}
                  cardEffect={
                    index === cardEffect.index ? cardEffect.effect : ''
                  }
                >
                  <p
                    onClick={(e) => {
                      e.preventDefault();
                      setCardEffect({
                        index: index,
                        effect: 'lowOpacity',
                      });
                      setTimeout(() => {
                        router.push(web_url + getSearchParams(), '', {
                          locale: getRouterLocale(router),
                        });
                      }, [200]);
                    }}
                  >
                    <li
                      onClick={() =>
                        fireClickedCardEvent(
                          'related Articles',
                          element.body,
                          pageType,
                          element.id,
                        )
                      }
                      className={
                        questions.length - 1 == index ? 'noBorder' : ''
                      }
                    >
                      <p className={'question_section'}>
                        <h3 className="question">{element.body}</h3>
                        <span className="views">
                          {' '}
                          {views && `${views} views`}
                        </span>
                      </p>
                      <img
                        loading="lazy"
                        src={images.arrowDownForward}
                        alt="arrow"
                      />
                    </li>
                  </p>
                </AnchorCoverTag>
              );
            })}
          </QNAList>
        </CardSection>
      ) : null}
    </>
  );
}
